import React from 'react';
import Icon from 'components/AppIcon';

const CATEGORIES = [
  { id: 'all', label: 'All', icon: 'Grid3X3' },
  { id: 'beauty', label: 'Beauty', icon: 'Sparkles' },
  { id: 'tech', label: 'Tech', icon: 'Cpu' },
  { id: 'home', label: 'Home', icon: 'Home' },
  { id: 'food', label: 'Food', icon: 'UtensilsCrossed' },
  { id: 'wellness', label: 'Wellness', icon: 'Heart' },
  { id: 'fashion', label: 'Fashion', icon: 'Shirt' },
  { id: 'books', label: 'Books', icon: 'BookOpen' },
];

export default function CategoryFilters({ activeCategory, onCategoryChange, resultCount }) {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-heading font-semibold text-lg md:text-xl" style={{ color: 'var(--color-foreground)' }}>
          Browse Products
        </h2>
        <span className="font-caption text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
          {resultCount} {resultCount === 1 ? 'product' : 'products'} found
        </span>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-2" style={{ scrollbarWidth: 'none' }}>
        {CATEGORIES?.map((cat) => {
          const isActive = activeCategory === cat?.id;
          return (
            <button
              key={cat?.id}
              onClick={() => onCategoryChange(cat?.id)}
              className="flex items-center gap-1.5 px-3 py-2 rounded-full font-caption text-sm font-medium whitespace-nowrap flex-shrink-0 transition-all duration-200 border"
              style={{
                background: isActive ? 'var(--color-accent)' : 'var(--color-background)',
                color: isActive ? 'var(--color-accent-foreground)' : 'var(--color-muted-foreground)',
                borderColor: isActive ? 'var(--color-accent)' : 'var(--color-border)',
                boxShadow: isActive ? 'var(--shadow-sm)' : 'none',
              }}
              aria-pressed={isActive}
            >
              <Icon name={cat?.icon} size={14} color={isActive ? 'var(--color-accent-foreground)' : 'currentColor'} strokeWidth={1.75} />
              {cat?.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}